// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"tab_tabContainer__1btov","menu":"tab_menu__2cS6-","tabLink":"tab_tabLink__2TbIz","selected":"tab_selected__3FvvF"};